import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

export const appSelector = createSelector(rootSelector, state => state.app);

export const languageSelector = createSelector(appSelector, app => app.language);
export const languagesSelector = createSelector(appSelector, app => app.languages);

export const licenseSelector = createSelector(appSelector, app => app.license);

export const isA11ySelector = createSelector(appSelector, app => app.isA11y);
